<template>
    <b-modal id="reports-modal" title="Reports" centered no-close-on-backdrop>
        <div v-for="(report, index) in reports" :key="index" class="my-3">
            <div>
                <strong>Reported by: </strong> {{ report.user.fullName }}
                <router-link
                    :to="`/users/${report.user.id}/edit`"
                    target="_blank"
                    class="ml-2"
                >
                    <i class="fas fa-external-link-alt" />
                </router-link>
            </div>
            <div>
                <span>
                    <strong>Type: </strong> {{ report.reportType || '-' }}
                </span>
            </div>
            <div>
                <span> <strong>Note: </strong> {{ report.note || '-' }} </span>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="close"
                >
                    Close
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            reports: []
        };
    },

    watch: {
        id() {
            this.fetchReports();
        }
    },

    created() {
        this.fetchReports();
    },

    methods: {
        ...mapActions({
            getFileReports: 'files/reports',
            getCommentReports: 'comments/reports'
        }),

        close() {
            this.$bvModal.hide('reports-modal');
        },

        async fetchReports() {
            if (!this.id) {
                return;
            }

            try {
                this.reports = await this[
                    this.type === 'files'
                        ? 'getFileReports'
                        : 'getCommentReports'
                ](this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
